export default "__VITE_ASSET__DN6EaCBw__"